'use strict';

var common = require('./common');

module.exports = function($) {

  var Game = require('./game')($);

  function MathDeck(gameOpts) {
    Game.call(this, gameOpts);
  }

  MathDeck.prototype = Object.create(Game.prototype);

  MathDeck.prototype.start = function() {
    Game.prototype.start.call(this);
    $('#deal').fadeOut();
  };

  MathDeck.prototype.nextQuestion = function() {
    if(!Game.prototype.nextQuestion.call(this)) return;
    $('#flip').fadeIn();
    $('.soln, .draw button').fadeOut();
    if(this.curQuestion.definitionImageUrl) {
      $('.equa').html('<img id="def_img" />');
      $('#def_img').attr('src', this.curQuestion.definitionImageUrl);
      $('.equa').fadeIn();
    } else {
      $('.equa').text(this.curQuestion.definition).fadeIn();
    }
    $('.stats').text(this.questionList.length + 1 + " cards left!");
  };

  MathDeck.prototype.flip = function() {
    $('#flip').fadeOut();
    $('.soln').text(this.curQuestion.word).fadeIn();
    $('.draw button').fadeIn();
  };

  MathDeck.prototype.returnCard = function() {
    this.questionList.push(this.curQuestion);
    this.questionList = common.shuffle(this.questionList);
    this.nextQuestion();
  };

  MathDeck.prototype.win = function() {
    $('.equa, .soln, .draw button').fadeOut();
    $('#deal').fadeIn();
    $('.stats').text('No cards left!');
  };

  return MathDeck;

};
